











import { Vue, Component, Prop } from 'vue-property-decorator'
import MainTitle from '../_components/MainTitle.vue'
import TagTitle from '../_components/TagTitle.vue'
import ChartClassRank from '../_components/charts/ChartClassRank.vue'
  @Component({
    components: {
      MainTitle,
      ChartClassRank,
      TagTitle
    }
  })
export default class extends Vue {
    @Prop({ required: true }) private title!: string
    @Prop({}) private tag!: string
    @Prop({ required: true }) private data!: any

    private list: Array < object > = [];
    created() {
      this.list = this.data.classCompareMathVos || [
        // {
        //   classroomName: 'aaa',
        //   maxScore: 90,
        //   median: 80,
        //   minScore: 60,
        //   standardDeviation: 10,
        //   mean: 78
        // }, {
        //   classroomName: 'aaa',
        //   maxScore: 90,
        //   median: 80,
        //   minScore: 60,
        //   standardDeviation: 10,
        //   mean: 78
        // }
      ]
    }
}
